module.exports = __webpack_public_path__ + "img/9788963711454.546b0b09.jpg";